module.exports = __webpack_public_path__ + "static/media/chat-bubble.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/chat-bubble.svg
// module id = 490
// module chunks = 0